import React from 'react';
import cn from 'classnames';
import WhatsMarked from 'react-whatsmarked';

interface Markdown {
  children: string;
  color?: 'gray-850' | 'white';
  size?: 14 | 40;
}

const Markdown = ({ children, color, size = 14 }: Markdown) => (
  <div
    className={cn('markdown', {
      [`markdown_${color}`]: color,
      [`markdown_${size}`]: size,
    })}
  >
    <WhatsMarked>{children}</WhatsMarked>
  </div>
);

export default Markdown;
